import { render, staticRenderFns } from "./AVW.vue?vue&type=template&id=264e2203&scoped=true&"
import script from "./AVW.vue?vue&type=script&lang=js&"
export * from "./AVW.vue?vue&type=script&lang=js&"
import style0 from "./AVW.vue?vue&type=style&index=0&id=264e2203&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e2203",
  null
  
)

export default component.exports